export default __webpack_public_path__ + "static/media/products-raw-icon.8da2989f.svg";